import React, { useState } from 'react';
import IconSelector from './IconSelector';

const AddDrinkModal = ({ isOpen, onClose, onAddDrink }) => {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [icon, setIcon] = useState('beer.png');
  const [sortOrder, setSortOrder] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Name ist erforderlich');
      return;
    }
    
    if (!price || isNaN(parseFloat(price)) || parseFloat(price) < 0) {
      setError('Bitte gib einen gültigen Preis ein');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const sortOrderValue = sortOrder ? parseInt(sortOrder) : null;
      await onAddDrink(name.trim(), parseFloat(price), icon, sortOrderValue);
      handleClose();
    } catch (error) {
      setError(error.message || 'Fehler beim Erstellen des Getränks');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setName('');
    setPrice('');
    setIcon('beer.png');
    setSortOrder('');
    setError('');
    onClose();
  };

  const handleIconChange = (newIcon) => {
    setIcon(newIcon);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
        <div className="text-center mb-6">
          <div className="text-4xl mb-2">🍺</div>
          <h2 className="text-2xl font-bold text-wood-800 mb-2">Neues Getränk</h2>
          <p className="text-wood-600 text-sm">Füge ein neues Getränk zur Karte hinzu</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div>
            <label className="block text-sm font-medium text-wood-700 mb-2">
              Name des Getränks
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border border-wood-300 rounded-lg focus:ring-2 focus:ring-beer-500 focus:border-transparent"
              placeholder="z.B. Craft Beer"
              disabled={isLoading}
            />
          </div>

          {/* Preis */}
          <div>
            <label className="block text-sm font-medium text-wood-700 mb-2">
              Preis (€)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="w-full px-4 py-3 border border-wood-300 rounded-lg focus:ring-2 focus:ring-beer-500 focus:border-transparent"
              placeholder="4.50"
              disabled={isLoading}
            />
          </div>

          {/* Icon */}
          <div>
            <label className="block text-sm font-medium text-wood-700 mb-2">
              Icon auswählen
            </label>
            <IconSelector
              selectedIcon={icon}
              onIconChange={handleIconChange}
              isOpen={isOpen}
            />
          </div>

          {/* Sortierreihenfolge */}
          <div>
            <label className="block text-sm font-medium text-wood-700 mb-2">
              Sortierreihenfolge (optional)
            </label>
            <input
              type="number"
              min="1"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="w-full px-4 py-3 border border-wood-300 rounded-lg focus:ring-2 focus:ring-beer-500 focus:border-transparent"
              placeholder="Automatisch (leer lassen)"
              disabled={isLoading}
            />
            <p className="text-xs text-wood-600 mt-1">
              Niedrigere Zahlen erscheinen zuerst. Leer lassen für automatische Sortierung.
            </p>
          </div>

          {/* Error */}
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          {/* Buttons */}
          <div className="flex space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 bg-wood-200 hover:bg-wood-300 text-wood-800 font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
              disabled={isLoading}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 bg-beer-600 hover:bg-beer-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Erstelle...' : 'Getränk hinzufügen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDrinkModal;
